import React from 'react'
import { default as dayjs } from 'dayjs'
import _ from 'lodash'
import PropTypes from 'prop-types'

import { Form } from '../../common/form/Form'
import { useAuthStore } from '../../store/auth'
import { useDependencies } from '../../store/dependencies'
import { getDependencyCall } from '../../lib/api/get'
import { useDeleteCall } from '../../lib/api/delete'

export const ChildForm = ({
  envData,
  crud,
  childFormData,
  closeChildForm,
  modalSchema,
  parentData,
  isLocalEnvironment,
}) => {
  React.useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        closeChildForm()
      }
    }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)
  }, [])
  const deleteCallMutation = useDeleteCall()
  const [activeTab, setActiveTab] = React.useState(0)
  const [enableEdit, setEnableEdit] = React.useState(false)
  const [editData, setEditData] = React.useState(null)
  const [deleteData, setDeleteData] = React.useState(null)
  const [deleteConfirm, setDeleteConfirm] = React.useState(false)
  const [addNewForm, setAddNewForm] = React.useState(false)
  const [revealData, setRevealData] = React.useState(false)
  const [revealDataId, setRevealDataId] = React.useState(null)

  const appState = useAuthStore((state) => state)
  const { setDependency } = useDependencies()

  const newFormAdd = () => {
    setAddNewForm(true)
  }

  const closeAdd = () => {
    setActiveTab(0)
  }

  const openDelete = (data) => {
    setDeleteConfirm(true)
    setDeleteData(data)
  }

  const closeDelete = () => {
    setDeleteConfirm(false)
    setDeleteData(null)
  }

  const openEdit = (data) => {
    setEnableEdit(true)
    setEditData(data)
  }

  const closeEdit = () => {
    setEnableEdit(false)
    setEditData(null)
  }

  const getDepData = async () => {
    const stateVar = { ...appState }
    const data = await getDependencyCall(
      isLocalEnvironment + '/getData',
      modalSchema.getDataAPI,
      modalSchema.noId
        ? '&isDependency=true'
        : '&id=' + parentData[modalSchema.getDataId] + '&isDependency=true',
    )
    if (!stateVar['dependeciesFormAPIS']) {
      stateVar['dependeciesFormAPIS'] = {}
    }
    stateVar['dependeciesFormAPIS'][modalSchema.getDataAPI] = modalSchema.noId
      ? data
      : data.formData
    setDependency(stateVar, stateVar.role, stateVar.roleId)
  }
  React.useEffect(() => {
    if (modalSchema.getData) {
      getDepData()
    }
  }, [])

  const onDelete = async () => {
    await deleteCallMutation
      .mutateAsync({
        url: isLocalEnvironment + '/deleteData',
        apiEndpoint: modalSchema.update.formAPI,
        parentAPI: modalSchema.update.parentAPI,
        id: modalSchema.update.isDeleteIdObject
          ? deleteData[modalSchema.update.deleteIdObject[0]][modalSchema.update.deleteIdObject[1]]
          : deleteData[modalSchema.update.id],
        messageTitle: modalSchema.update.deleteMessage.title,
        message: modalSchema.update.deleteMessage.message,
        isDynamic: true,
        params: '',
      })
      .then(() => {
        closeDelete()
        closeChildForm()
      })
  }

  const proForm = [
    {
      name: 'List',
    },
    {
      name: 'Add',
    },
  ]

  const showStartAndEnd = (data, isSingle = false) => {
    const dataArray = {}
    const filtData = data.filter((f) => f[modalSchema.filterBy] === modalSchema.filterByValue)
    filtData
      .sort((a, b) => new Date(a.createdDateTime) - new Date(b.createdDateTime))
      .map((m, mI) => {
        if (mI === 0) {
          dataArray['first'] = m
        }
        if (mI === filtData.length - 1) {
          dataArray['last'] = m
        }
      })
    const grp = _.groupBy(filtData, 'academicYearHolidayName')
    const groupArr = _.values(grp)
    const arrRet = {}
    const displayVacation = (arr) => {
      arr.map((a, aI) => {
        if (aI === 0) {
          arrRet['first'] = a
        }
        if (aI === arr.length - 1) {
          arrRet['last'] = a
        }
      })
      if (isSingle) {
        var weekday = new Array(7)
        weekday[0] = 'Sunday'
        weekday[1] = 'Monday'
        weekday[2] = 'Tuesday'
        weekday[3] = 'Wednesday'
        weekday[4] = 'Thursday'
        weekday[5] = 'Friday'
        weekday[6] = 'Saturday'

        return (
          <strong>
            {weekday[dayjs(arrRet.first.academicYearHolidayDate).day()]} is weekly holiday
          </strong>
        )
      } else {
        return (
          <strong>
            {arrRet.first.academicYearHolidayName} from{' '}
            {dayjs(arrRet.first.academicYearHolidayDate).format('DD-MM-YYYY')} to{' '}
            {dayjs(arrRet.last.academicYearHolidayDate).format('DD-MM-YYYY')}
          </strong>
        )
      }
    }

    return groupArr.map((group, groupIndex) => (
      <div className="mb-2" key={`${groupIndex}${group}`}>
        {displayVacation(group)}
      </div>
    ))
  }

  const dataReavealFunc = (id) => {
    setRevealDataId(id)
    setRevealData(true)
  }

  return (
    <div
      className="trtui-modal trtui-modal-xl trtui-fade trtui-show"
      aria-labelledby="exampleModalLabel"
      style={{ display: 'block', backgroundColor: 'rgba(55,55,55,0.3)' }}
      aria-modal="true"
      role="dialog"
    >
      <div className="trtui-modal-dialog trtui-modal-xl">
        <div className="trtui-modal-content">
          <div className="trtui-modal-header trtui-bg-light trtui-p-3">
            <h5 className="trtui-modal-title" id="exampleModalLabel">
              {modalSchema.formTitle}
            </h5>
            <button
              type="button"
              className="trtui-btn-close"
              onClick={() => closeChildForm()}
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ri-close-line" />
            </button>
          </div>
          <div className="trtui-modal-body">
            <div className="trtui-card">
              <div className="trtui-card-header">
                <ul
                  className="trtui-nav trtui-nav-tabs-custom trtui-rounded trtui-card-header-tabs trtui-border-bottom-0"
                  role="tablist"
                >
                  {!enableEdit &&
                    proForm.length > 0 &&
                    proForm.map((form, formIndex) => (
                      <li className="trtui-nav-item" role="presentation" key={formIndex}>
                        <span
                          className={`trtui-nav-link trtui-cursor-pointer ${
                            activeTab === formIndex ? 'trtui-active' : ''
                          }`}
                          data-bs-toggle="tab"
                          role="tab"
                          onClick={() => setActiveTab(formIndex)}
                        >
                          {form.name}
                        </span>
                      </li>
                    ))}
                </ul>
              </div>
              <div className="trtui-card-body trtui-p-4">
                {addNewForm && (
                  <div>
                    <Form
                      setOpenFormModal={closeEdit}
                      defaultData={editData}
                      mainData={parentData}
                      isChildForm={true}
                      closeChildForm={closeChildForm}
                      envData={envData}
                      formSchema={modalSchema.update}
                      modSchema={modalSchema}
                      crud={crud}
                      isLocalEnvironment={isLocalEnvironment}
                    />
                  </div>
                )}
                {enableEdit ? (
                  <div>
                    <Form
                      setOpenFormModal={closeEdit}
                      defaultData={editData}
                      mainData={parentData}
                      envData={envData}
                      formSchema={modalSchema.update}
                      modSchema={modalSchema}
                      crud={crud}
                      isLocalEnvironment={isLocalEnvironment}
                    />
                  </div>
                ) : deleteConfirm ? (
                  <div>
                    <div className="trtui-mt-2 trtui-text-center">
                      <lord-icon
                        src="https://cdn.lordicon.com/gsqxdxog.json"
                        trigger="loop"
                        colors="primary:#f7b84b,secondary:#f06548"
                        style={{ width: '100px', height: '100px' }}
                      />
                      <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                        <h4>Are you Sure ?</h4>
                        <p className="trtui-text-muted trtui-mx-4 trtui-mb-0">
                          Are you sure, you want to delete this?
                        </p>
                      </div>
                    </div>
                    <div className="trtui-d-flex trtui-gap-2 trtui-justify-content-center trtui-mt-4 trtui-mb-2">
                      <button
                        type="button"
                        className="trtui-btn trtui-w-sm trtui-btn-light"
                        disabled={deleteCallMutation.isLoading}
                        data-bs-dismiss="modal"
                        onClick={() => {
                          closeDelete()
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="trtui-btn trtui-w-sm trtui-btn-danger"
                        disabled={deleteCallMutation.isLoading}
                        onClick={() => onDelete()}
                      >
                        {deleteCallMutation.isLoading ? (
                          <span className="trtui-d-flex trtui-align-items-center">
                            <span className="trtui-flex-grow-1 trtui-me-2">Deleting...</span>
                            <span
                              className="trtui-spinner-border trtui-flex-shrink-0"
                              role="status"
                            >
                              <span className="trtui-visually-hidden">Deleting...</span>
                            </span>
                          </span>
                        ) : (
                          'Yes, Delete It!'
                        )}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="trtui-tab-content">
                    <div
                      className={`trtui-tab-pane ${activeTab === 0 ? 'trtui-active' : ''}`}
                      role="tabpanel"
                    >
                      <div className="trtui-table-responsive trtui-mt-xl-0">
                        <table className="trtui-table trtui-table-white trtui-table-striped trtui-table-nowrap trtui-align-middle trtui-mb-0">
                          <thead>
                            <tr>
                              {modalSchema.view.tableHeaders.map((h, hInd) => (
                                <th scope="col" key={hInd}>
                                  {h}
                                </th>
                              ))}
                              {modalSchema.view.noActions !== true && <th scope="col">Action</th>}
                            </tr>
                          </thead>
                          {modalSchema.filterBy && modalSchema.filterByValue ? (
                            <tbody>
                              {modalSchema.isSingleEntry ? (
                                <tr>
                                  <td>{showStartAndEnd(childFormData, true)}</td>
                                </tr>
                              ) : modalSchema.showStartAndEnd ? (
                                <tr>
                                  <td>{showStartAndEnd(childFormData, false)}</td>
                                </tr>
                              ) : (
                                childFormData.length > 0 &&
                                childFormData
                                  .filter(
                                    (f) => f[modalSchema.filterBy] === modalSchema.filterByValue,
                                  )
                                  .map((c, cInd) => (
                                    <tr key={cInd}>
                                      {modalSchema.view.valFromObj
                                        ? modalSchema.view.obj.map((r, rInd) => (
                                            <td key={rInd}>
                                              {(r.length > 1 ? r[1].type : r[0].type) &&
                                              (r.length > 1 ? r[1].type : r[0].type) === 'date' ? (
                                                dayjs(
                                                  r.length > 1 ? c[r[0]][r[1]] : c[r[0]],
                                                ).format('MM-DD-YYYY')
                                              ) : (r.length > 1 ? r[1].type : r[0].type) &&
                                                (r.length > 1 ? r[1].type : r[0].type) ===
                                                  'bool' ? (
                                                <i
                                                  className={`${c[r.field] === 1 ? 'ri-checkbox-line trtui-text-success-emphasis' : 'ri-checkbox-blank-line trtui-text-danger-emphasis'}`}
                                                />
                                              ) : r.length > 1 ? (
                                                c[r[0]][r[1]]
                                              ) : (
                                                c[r[0]]
                                              )}
                                            </td>
                                          ))
                                        : modalSchema.view.tableRows.map((r, rInd) => (
                                            <td key={rInd}>
                                              {r.type && r.type === 'date' ? (
                                                dayjs(c[r.field]).format('MM-DD-YYYY')
                                              ) : r.type && r.type === 'bool' ? (
                                                <i
                                                  className={`${c[r.field] === 1 ? 'ri-checkbox-line trtui-text-success-emphasis' : 'ri-checkbox-blank-line trtui-text-danger-emphasis'}`}
                                                />
                                              ) : (
                                                c[r]
                                              )}
                                            </td>
                                          ))}
                                      {modalSchema.view.noActions !== true && (
                                        <td>
                                          <div className="trtui-hstack trtui-gap-3 trtui-flex-wrap">
                                            {!modalSchema.noUpdate && (
                                              <span
                                                onClick={() => openEdit(c)}
                                                className="trtui-link-success trtui-fs-15 trtui-cursor-pointer"
                                              >
                                                <i className="ri-edit-2-line" />
                                              </span>
                                            )}
                                            {!modalSchema.noDelete && (
                                              <span
                                                onClick={() => openDelete(c)}
                                                className="trtui-link-danger trtui-fs-15"
                                              >
                                                <i className="ri-delete-bin-line" />
                                              </span>
                                            )}
                                          </div>
                                        </td>
                                      )}
                                    </tr>
                                  ))
                              )}
                            </tbody>
                          ) : (
                            <tbody>
                              {childFormData?.length &&
                                childFormData.length > 0 &&
                                childFormData.map((c, cInd) => (
                                  <tr key={cInd}>
                                    {modalSchema.view.valFromObj
                                      ? modalSchema.view.obj.map((r, rInd) => (
                                          <td key={rInd}>
                                            {(r.length > 1 ? r[1].type : r[0].type) &&
                                            (r.length > 1 ? r[1].type : r[0].type) === 'date' ? (
                                              dayjs(r.length > 1 ? c[r[0]][r[1]] : c[r[0]]).format(
                                                'MM-DD-YYYY',
                                              )
                                            ) : (r.length > 1 ? r[1].type : r[0].type) &&
                                              (r.length > 1 ? r[1].type : r[0].type) === 'bool' ? (
                                              <i
                                                className={`${(r.length > 1 ? c[r[0]][r[1].field] : c[r[0].field]) === 1 ? 'ri-checkbox-line trtui-text-success-emphasis' : 'ri-checkbox-blank-line trtui-text-danger-emphasis'}`}
                                              />
                                            ) : (r.length > 1 ? r[1].type : r[0].type) &&
                                              (r.length > 1 ? r[1].type : r[0].type) ===
                                                'showBtn' ? (
                                              <>
                                                {revealData && revealDataId === cInd ? (
                                                  <>
                                                    {r[0].dataType?.type === 'concat'
                                                      ? c[r[0].dataType?.fields[0]] +
                                                        (c[r[0].dataType?.fields[1]] === null
                                                          ? ''
                                                          : c[r[0].dataType?.fields[1]])
                                                      : r.length > 1
                                                        ? c[r[0]][r[1]]
                                                        : c[r[0]]}
                                                  </>
                                                ) : (
                                                  <button
                                                    className="trtui-btn trtui-btn-sm trtui-btn-primary"
                                                    onClick={() => dataReavealFunc(cInd)}
                                                  >
                                                    Show
                                                  </button>
                                                )}
                                              </>
                                            ) : r.length > 1 ? (
                                              c[r[0]][r[1]]
                                            ) : (
                                              c[r[0]]
                                            )}
                                          </td>
                                        ))
                                      : modalSchema.view.tableRows.map((r, rInd) => (
                                          <td key={rInd}>
                                            {r.type && r.type === 'date' ? (
                                              dayjs(c[r.field]).format('MM-DD-YYYY')
                                            ) : r.type && r.type === 'bool' ? (
                                              <i
                                                className={`${c[r.field] === 1 ? 'ri-checkbox-line trtui-text-success-emphasis' : 'ri-checkbox-blank-line trtui-text-danger-emphasis'}`}
                                              />
                                            ) : (
                                              c[r]
                                            )}
                                          </td>
                                        ))}
                                    <td>
                                      <div className="trtui-hstack trtui-gap-3 trtui-flex-wrap">
                                        {!modalSchema.noUpdate && (
                                          <span
                                            onClick={() => openEdit(c)}
                                            className="trtui-link-success trtui-fs-15 trtui-cursor-pointer"
                                          >
                                            <i className="ri-edit-2-line" />
                                          </span>
                                        )}
                                        {!modalSchema.noDelete && (
                                          <span
                                            onClick={() => openDelete(c)}
                                            className="trtui-link-danger trtui-fs-15"
                                          >
                                            <i className="ri-delete-bin-line" />
                                          </span>
                                        )}
                                        <span
                                          href={
                                            modalSchema.openNewWindowLink +
                                            c[modalSchema.openNewWindowLinkParam]
                                          }
                                          onClick={() =>
                                            newFormAdd(c[modalSchema.openNewWindowLinkParam])
                                          }
                                          className="trtui-link-success trtui-fs-15"
                                        >
                                          {modalSchema.openNewWindowLinkName}
                                        </span>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          )}
                        </table>
                      </div>
                    </div>
                    <div
                      className={`trtui-tab-pane ${activeTab === 1 ? 'trtui-active' : ''}`}
                      role="tabpanel"
                    >
                      <Form
                        setOpenFormModal={closeAdd}
                        isChildForm={true}
                        closeChildForm={closeChildForm}
                        defaultData={editData}
                        mainData={parentData}
                        envData={envData}
                        formSchema={modalSchema.create}
                        modSchema={modalSchema}
                        crud={crud}
                        parentId={parentData[modalSchema.create.parentId]}
                        parentData={parentData}
                        isAdd={true}
                        isLocalEnvironment={isLocalEnvironment}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

ChildForm.propTypes = {
  envData: PropTypes.object,
  listKey: PropTypes.number,
  childFormData: PropTypes.object,
  setChildFormData: PropTypes.func,
  closeChildForm: PropTypes.object,
  modalSchema: PropTypes.object,
  parentData: PropTypes.object,
  isLocalEnvironment: PropTypes.string,
  crud: PropTypes.number,
}
